import contactUsJson from './content/contact-us.json';

export const contactUsMock = {
    layoutType: 2,
    data: {
        name: 'contact-us',
        areasList: [
            {
                id: 1,
                name: 'ContactPage',
                componentName: 'Comp:ContactPage',
                content: JSON.stringify(contactUsJson)
            }
        ]
    }
};
